import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import { UpdateStatusShape, UserFilter, UserFilterFormatted } from "@shared/interfaces";

import { CreateUserDto, CreateUserSessionDto } from "../interfaces";

export default {
  getUsers: (payload: UserFilter) => {
    const { hospital, ...restParams } = payload;
    const params: UserFilterFormatted = {
      ...restParams,
      search: payload.search?.trim(),
    };

    if (hospital) {
      params.hospital_id = Number(hospital.value);
    }

    return request(METHODS.GET, API.USER.GET_USERS)({ params });
  },
  createUser: (payload: CreateUserDto) => request(METHODS.POST, API.USER.CREATE_USER)(payload),
  updateUserStatus: (payload: UpdateStatusShape) => {
    const { id, status } = payload;
    return request(METHODS.PUT, API.USER.UPDATE_USER_STATUS(String(id)))({ status });
  },
  updateUser: (payload: CreateUserDto & { id: number }) => {
    const { id, ...rest } = payload;
    return request(METHODS.PUT, API.USER.UPDATE_USER(String(id)))(rest);
  },
  createUserSession: (payload: CreateUserSessionDto) =>
    request(METHODS.POST, API.USER_SESSION.CREATE_USER_SESSION)(payload),
  updateUserSession: (id: number) => request(METHODS.PUT, API.USER_SESSION.UPDATE_USER_SESSION(String(id)))(),
};
